import { translate } from '../Helper';

export default function LatestProMissingNotice() {
    return (
        <div className="ecre-flex ecre-justify-center ecre-w-full ecre-mt-8">
            <div className="ecre-bg-red-100 ecre-border-l-4 ecre-border-red-50 ecre-text-red-700 ecre-p-4 ecre-rounded">
                <h1 className="ecre-font-bold ecre-text-lg">
                    {translate('upgrade_older_version_pro')}, 
                    which may cause compatibility issues.
                </h1>
                <p className="ecre-mt-2 ecre-text-sm ecre-text-center">
                    Please{' '}
                    <a
                        href="https://wppool.dev/account-login/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ecre-font-bold ecre-text-blue-700 ecre-hover:underline"
                    >
                        download the latest Pro plugin
                    </a>{' '}
                    and enjoy all the new features and benefits.
                </p>
            </div>
        </div>
    );
}
